import { ReactComponent as Close } from '@public/icons/close.svg';
import Icon from '../atoms/Icon';

const IconClose = (props) => <Icon as={Close} {...props} />;

IconClose.propTypes = Icon.propTypes;

export default IconClose;
